import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper'
import { Fancybox } from '@fancyapps/ui'

import '@fancyapps/ui/dist/fancybox/fancybox.css'
import './trip-agenda.scss'

Fancybox.bind('[data-fancybox="trip"]')

const selectors = {
  container: '[data-ta]',

  popup: '[data-ta-popup]',
  popupTrigger: '[data-ta-popup-trigger]',

  blockTab: '[data-ta-tab="block"]',
  popupTab: '[data-ta-tab="popup"]',
  popupPane: '[data-ta-pane]',

  active: 'active',
}

const initTripAgendaPopup = (container) => {
  const popup = container.querySelector(selectors.popup)
  const triggers = container.querySelectorAll(selectors.popupTrigger)

  triggers.forEach((trigger) =>
    trigger.addEventListener('click', () => {
      popup.classList.toggle(selectors.active)
      document.body.classList.toggle('no-scroll')
    })
  )
}

const handleTabClick = (activeIndex, tabs, panes) => {
  tabs.forEach((tab, index) => tab.classList[activeIndex === index ? 'add' : 'remove'](selectors.active))
  panes.forEach((pane, index) => pane.classList[activeIndex === index ? 'add' : 'remove'](selectors.active))
}

const initTripAgendaTabs = (container) => {
  const blockTabs = container.querySelectorAll(selectors.blockTab)
  const popupTabs = container.querySelectorAll(selectors.popupTab)
  const panes = container.querySelectorAll(selectors.popupPane)

  blockTabs.forEach((tab, activeIndex) => tab.addEventListener('click', () => handleTabClick(activeIndex, popupTabs, panes)))
  popupTabs.forEach((tab, activeIndex) => tab.addEventListener('click', () => handleTabClick(activeIndex, popupTabs, panes)))
}

const initTripAgendaSlider = (container) => {
  const slides = container.querySelectorAll('.swiper-slide')

  new Swiper(container.querySelector('.swiper'), {
    modules: [Navigation, Scrollbar, Pagination],

    slidesPerView: 1,
    spaceBetween: 16,

    scrollbar: {
      el: container.querySelector('.swiper-scrollbar'),
      draggable: true,
    },

    navigation: {
      prevEl: container.querySelector('.prev'),
      nextEl: container.querySelector('.next'),
    },

    pagination: {
      el: container.querySelector('.swiper-pagination'),
    },

    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const containers = document.querySelectorAll(selectors.container)

    containers?.forEach((container) => {
      initTripAgendaSlider(container)
      initTripAgendaPopup(container)
      initTripAgendaTabs(container)
    })
  },
  { once: true }
)
